module.exports = ".row:nth-child(odd){\r\n    background: #ececec;   \r\n}\r\n\r\n.row{\r\n    padding: 1em 0px 0px 0px !important;\r\n}\r\n\r\n.mat-form-field-wrapper{\r\n    padding-bottom:0px !important;\r\n}\r\n\r\n.field-title{\r\n    width:113px;\r\n    display:inline-block;\r\n    color:#807f7f;\r\n}\r\n\r\ntd{\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/built-drawing/built-drawing-form/built-drawing-form.component.css
// module id = ./src/app/planning/built-drawing/built-drawing-form/built-drawing-form.component.css
// module chunks = main